module.exports = __webpack_public_path__ + "img/intranet.a2aa5d5.png";